import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { PopupComponent } from "./popup.component";
import { ContentModule } from "@app/main/content/game-settings/popup/content/content.module";
import { MaterialModule } from "@app/material/material.module";
import { ContentComponent } from "@app/main/content/game-settings/popup/content/content.component";
import { AdFormComponent } from "@app/main/content/game-settings/ad-form/ad-form.component";
@NgModule({
  imports: [CommonModule, ContentModule, MaterialModule],
  declarations: [PopupComponent],
  exports: [PopupComponent],
  entryComponents: [ContentComponent, AdFormComponent],
})
export class PopupModule {}
